import React from 'react';
import '../PullQuote/pullQuote.scss';

const PullQuote = ({ content }) => {
  return (
    <div className="pullQuote">
      <div className="pullQuote__text">
        <p className="chapter__paragraph">{content}</p>
      </div>
    </div>
  );
};

export default PullQuote;
